(function () {
  'use strict';
  var node = document.getElementById('FacGiftConfig');
  if (!node || !window.FacGiftRules) return;
  var config = JSON.parse(node.textContent);
  config.identified = Boolean(config.loggedIn || localStorage.getItem('facGiftEmail'));
  var root = config.root.replace(/\/?$/, '/');
  var originalFetch = window.fetch.bind(window);
  var running = null;
  var queued = false;
  var applying = false;
  var knownCodes = [];
  var lastDiscountAttempt = null;
  function request(path, body) {
    return originalFetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cadeau : réponse du panier ' + response.status);
      return response.json();
    });
  }
  function message(plan) {
    document.querySelectorAll('#cmd-form, #CartPageForm, #CartDrawerForm').forEach(function (form) {
      var note = form.querySelector('[data-fac-gift-message]');
      if (!config.enabled || !config.code) { if (note) note.remove(); return; }
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-fac-gift-message', '');
        note.setAttribute('role', 'status');
        note.className = 'fac-gift-cart-message';
        form.prepend(note);
      }
      note.textContent = config.returning
        ? 'Vous avez déjà commandé chez nous : ce cadeau de bienvenue est réservé à la première commande.'
        : plan.eligible
          ? ''
          : !config.available
            ? 'Le cadeau de bienvenue est actuellement épuisé.'
            : 'Un lait VIP O2 50 ml offert pour votre première commande dès ' + (config.minimum / 100) + ' € d’achat, hors cadeau.';
      note.hidden = !note.textContent;
    });
  }
  async function syncOnce() {
    var cart = await request('cart.js');
    var plan = window.FacGiftRules.plan(cart, config);
    var changed = false;
    knownCodes = (cart.discount_codes || []).map(function (entry) { return entry.code; });
    if (Object.keys(plan.updates).length) {
      cart = await request('cart/update.js', { updates: plan.updates }); changed = true;
    }
    if (plan.add) {
      await request('cart/add.js', { items: [{ id: config.giftId, quantity: 1, properties: { _cadeau: 'Bienvenue' } }] });
      changed = true;
    }
    var present = knownCodes.some(function (code) { return code.toLowerCase() === (config.code || '').toLowerCase(); });
    var discountAttempt = JSON.stringify([config.code, plan.eligible, plan.amount, cart.items.map(function (item) { return [item.key, item.quantity]; })]);
    if (config.code && plan.eligible !== present && discountAttempt !== lastDiscountAttempt) {
      var codes = knownCodes.filter(function (code) { return code.toLowerCase() !== config.code.toLowerCase(); });
      if (plan.eligible) codes.push(config.code);
      await request('cart/update.js', { discount: codes.join(',') });
      lastDiscountAttempt = discountAttempt;
      knownCodes = codes; changed = true;
    }
    if (changed) {
      var controller = window.MaxDesign && window.MaxDesign.cart && window.MaxDesign.cart.controller;
      if (controller && controller.fetch && controller.render) controller.render(await controller.fetch());
      else {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      }
    }
    message(plan);
    fixTotals();
    return plan;
  }
  // Le total affiché ne doit pas compter le lait offert (la remise Shopify s'applique après l'e-mail).
  function fixTotals() {
    request('cart.js').then(function (cart) {
      var gift = cart.items.filter(function (i) { return i.properties && i.properties._cadeau; })
        .reduce(function (s, i) { return s + i.final_line_price; }, 0);
      if (!gift) return;
      var txt = (cart.total_price - gift) / 100;
      var fmt = txt.toLocaleString('fr-FR', { minimumFractionDigits: txt % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';
      document.querySelectorAll('[data-price-cart-total]').forEach(function (el) { el.textContent = fmt; });
    }).catch(function () {});
  }
  document.addEventListener('maxdesign:cart:render', function () { setTimeout(fixTotals, 50); });
  function check() {
    if (running) { queued = true; return running; }
    applying = true;
    running = syncOnce().catch(function (error) { console.warn(error.message); throw error; }).finally(function () {
      running = null; applying = false;
      if (queued) { queued = false; setTimeout(schedule, 250); }
    });
    return running;
  }
  function schedule() { if (!applying) check().catch(function () {}); }
  ['maxdesign:cart:add', 'maxdesign:cart:change', 'maxdesign:cart:update', 'ajaxProduct:added'].forEach(function (event) {
    document.addEventListener(event, schedule);
  });
  document.addEventListener('maxdesign:cart:render', function () {
    if (!applying) schedule();
  });
  window.fetch = function (input, options) {
    var url = typeof input === 'string' ? input : input && input.url || '';
    var response = originalFetch(input, options);
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
      response.then(function (result) { if (result.ok) setTimeout(schedule, 250); }).catch(function () {});
    }
    return response;
  };
  // Passage au paiement : on capture le clic avant le panier MaxDesign (qui redirige directement vers /checkout)
  // pour transmettre le code cadeau et l'e-mail saisi, sinon Shopify affiche le lait payant.
  var SF_TOKEN = '0e0ce33a84b719ec6f74ac5179821b86';
  function sf(query, variables) {
    return fetch('/api/2025-01/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN }, body: JSON.stringify({ query: query, variables: variables }) }).then(function (r) { return r.json(); });
  }
  function sfCheckout(email, codes) {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var id = 'gid://shopify/Cart/' + cart.token;
      var steps = Promise.resolve(null);
      if (email) steps = steps.then(function () { return sf('mutation($id:ID!,$b:CartBuyerIdentityInput!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:$b){cart{checkoutUrl}userErrors{message}}}', { id: id, b: { email: email, countryCode: 'FR' } }).then(function (d) { var c = d.data && d.data.cartBuyerIdentityUpdate.cart; return c && c.checkoutUrl; }); });
      if (codes.length) steps = steps.then(function (u) { return sf('mutation($id:ID!,$c:[String!]){cartDiscountCodesUpdate(cartId:$id,discountCodes:$c){cart{checkoutUrl}userErrors{message}}}', { id: id, c: codes }).then(function (d) { var c = d.data && d.data.cartDiscountCodesUpdate.cart; return (c && c.checkoutUrl) || u; }); });
      return steps;
    });
  }
  function goCheckout() {
    var field = document.querySelector('[data-fac-gift-email]');
    var typed = field && field.value.trim();
    if (typed && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(typed)) { localStorage.setItem('facGiftEmail', typed); config.identified = true; }
    return check().then(function (plan) {
      var params = [];
      var email = localStorage.getItem('facGiftEmail');
      var codes = knownCodes.slice();
      if (plan.eligible && codes.indexOf(config.code) < 0) codes.push(config.code);
      if (codes.length) params.push('discount=' + encodeURIComponent(codes.join(',')));
      if (email) params.push('checkout[email]=' + encodeURIComponent(email));
      var fallback = root + 'checkout' + (params.length ? '?' + params.join('&') : '');
      return sfCheckout(email, codes).then(function (url) { location.assign(url || fallback); }, function () { location.assign(fallback); });
    });
  }
  window.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!btn || !config.enabled || !config.code) return;
    var terms = document.querySelector('.cmd-terms input[type="checkbox"], #cmd-form [name="terms"]');
    if (terms && !terms.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    goCheckout().catch(function () {
      alert('Le cadeau n’a pas pu être vérifié. Merci de réessayer avant de passer au paiement.');
    });
  }, true);
  function saveEmail(box, event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var input = box.querySelector('[data-fac-gift-email]');
    var btn = box.querySelector('button');
    var v = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { input.setCustomValidity('Adresse e-mail invalide'); input.reportValidity(); input.setCustomValidity(''); return; }
    localStorage.setItem('facGiftEmail', v);
    config.identified = true;
    if (btn) { btn.textContent = 'Enregistré ✓'; btn.disabled = true; setTimeout(function () { btn.textContent = 'Modifier'; btn.disabled = false; }, 1800); }
    check().catch(function () {});
  }
  window.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.fac-gift-box__form button, [data-fac-gift-form] button');
    if (btn) saveEmail(btn.closest('.fac-gift-box__form, [data-fac-gift-form]') || btn.parentNode, event);
  }, true);
  window.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-fac-gift-email]')) saveEmail(event.target.closest('.fac-gift-box__form, [data-fac-gift-form]') || event.target.parentNode, event);
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.target.matches || !event.target.matches('[data-fac-gift-form]')) return;
    event.preventDefault();
    var input = event.target.querySelector('[data-fac-gift-email]');
    var v = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { input.setCustomValidity('Adresse e-mail invalide'); input.reportValidity(); input.setCustomValidity(''); return; }
    localStorage.setItem('facGiftEmail', v);
    config.identified = true;
    check().catch(function () {});
  }, true);
  function fillEmail() {
    var v = localStorage.getItem('facGiftEmail');
    if (v) document.querySelectorAll('[data-fac-gift-email]').forEach(function (el) { if (!el.value) el.value = v; });
  }
  document.addEventListener('maxdesign:cart:render', function () { setTimeout(fillEmail, 50); });
  window.addEventListener('pageshow', schedule);
  fillEmail();
  schedule();
})();